import { useContext } from 'react';
import { Card, CardContent, Typography, CardHeader, Avatar, Divider } from '@mui/material';
import AssignmentIcon from '@mui/icons-material/Assignment';
import { useFormContext } from 'react-hook-form';
import { FormSelectableContext } from 'src/shared/components/form/formSelectableStateContext';
import ConsoleHelper from 'src/shared/functions/consoleHelper';

interface SummaryList {
  label: string;
  fieldName: string;
}

type FormSummaryProps = {
  formSummaryList: Array<SummaryList> | undefined;
};

export const FormSummary = ({ formSummaryList }: FormSummaryProps) => {
  ConsoleHelper.log('formsummary');
  const { watch } = useFormContext();
  const { items } = useContext(FormSelectableContext);

  const getSelectBoxLabel = (findName: string) => {
    const foundItem = items.find((item) => item.name === findName);
    return foundItem ? foundItem.selectableItem.label : null;
  };

  return (
    <Card
      variant='outlined'
      sx={{
        m: 1,
        borderWidth: 2,
      }}
    >
      <CardHeader
        avatar={
          <Avatar variant='rounded'>
            <AssignmentIcon />
          </Avatar>
        }
        title={<Typography variant='h5'>Summering</Typography>}
      />
      <Divider variant='middle' />
      <CardContent>
        {formSummaryList &&
          formSummaryList.map((item) => {
            if (watch(item.fieldName)) {
              const hasLabel = getSelectBoxLabel(item.fieldName);
              return (
                <div key={item.fieldName}>
                  <Typography color='textSecondary' variant='body2'>
                    {item.label}
                  </Typography>
                  <Typography variant='h6' gutterBottom sx={{ lineHeight: 1.2 }}>
                    {hasLabel ?? watch(item.fieldName)}
                  </Typography>
                </div>
              );
            }
            return null;
          })}
      </CardContent>
    </Card>
  );
};
